// @generated by protobuf-ts 2.11.1 with parameter long_type_number,generate_dependencies
// @generated from protobuf file "shared/domains/vlp-billing/vlp-billing-topup-attention-request-response.proto" (package "vlp.billing", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ActionResponse } from "../../../common";
/**
 * @generated from protobuf message vlp.billing.TopupAttentionSettingsDTO
 */
export interface TopupAttentionSettingsDTO {
    /**
     * @generated from protobuf field: int32 version = 1
     */
    version: number;
    /**
     * @generated from protobuf field: bool enabled = 2
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: bool sound_enabled = 3
     */
    soundEnabled: boolean;
    /**
     * @generated from protobuf field: bool icon_enabled = 4
     */
    iconEnabled: boolean;
    /**
     * @generated from protobuf field: int32 ring_count = 5
     */
    ringCount: number;
    /**
     * @generated from protobuf field: int32 reminder_minutes = 6
     */
    reminderMinutes: number;
    /**
     * @generated from protobuf field: int32 escalation_minutes = 7
     */
    escalationMinutes: number;
    /**
     * @generated from protobuf field: int32 max_reminders = 8
     */
    maxReminders: number;
    /**
     * @generated from protobuf field: int32 max_age_days = 9
     */
    maxAgeDays: number;
    /**
     * @generated from protobuf field: bool popup_on_new = 10
     */
    popupOnNew: boolean;
    /**
     * @generated from protobuf field: bool popup_on_login = 11
     */
    popupOnLogin: boolean;
}
/**
 * @generated from protobuf message vlp.billing.TopupAttentionSettingsResponse
 */
export interface TopupAttentionSettingsResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.billing.TopupAttentionSettingsDTO data = 2
     */
    data?: TopupAttentionSettingsDTO;
}
// @generated message type with reflection information, may provide speed optimized methods
class TopupAttentionSettingsDTO$Type extends MessageType<TopupAttentionSettingsDTO> {
    constructor() {
        super("vlp.billing.TopupAttentionSettingsDTO", [
            { no: 1, name: "version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "sound_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "icon_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "ring_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "reminder_minutes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "escalation_minutes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "max_reminders", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "max_age_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "popup_on_new", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "popup_on_login", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TopupAttentionSettingsDTO>): TopupAttentionSettingsDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.version = 0;
        message.enabled = false;
        message.soundEnabled = false;
        message.iconEnabled = false;
        message.ringCount = 0;
        message.reminderMinutes = 0;
        message.escalationMinutes = 0;
        message.maxReminders = 0;
        message.maxAgeDays = 0;
        message.popupOnNew = false;
        message.popupOnLogin = false;
        if (value !== undefined)
            reflectionMergePartial<TopupAttentionSettingsDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TopupAttentionSettingsDTO): TopupAttentionSettingsDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 version */ 1:
                    message.version = reader.int32();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                case /* bool sound_enabled */ 3:
                    message.soundEnabled = reader.bool();
                    break;
                case /* bool icon_enabled */ 4:
                    message.iconEnabled = reader.bool();
                    break;
                case /* int32 ring_count */ 5:
                    message.ringCount = reader.int32();
                    break;
                case /* int32 reminder_minutes */ 6:
                    message.reminderMinutes = reader.int32();
                    break;
                case /* int32 escalation_minutes */ 7:
                    message.escalationMinutes = reader.int32();
                    break;
                case /* int32 max_reminders */ 8:
                    message.maxReminders = reader.int32();
                    break;
                case /* int32 max_age_days */ 9:
                    message.maxAgeDays = reader.int32();
                    break;
                case /* bool popup_on_new */ 10:
                    message.popupOnNew = reader.bool();
                    break;
                case /* bool popup_on_login */ 11:
                    message.popupOnLogin = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TopupAttentionSettingsDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 version = 1; */
        if (message.version !== 0)
            writer.tag(1, WireType.Varint).int32(message.version);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        /* bool sound_enabled = 3; */
        if (message.soundEnabled !== false)
            writer.tag(3, WireType.Varint).bool(message.soundEnabled);
        /* bool icon_enabled = 4; */
        if (message.iconEnabled !== false)
            writer.tag(4, WireType.Varint).bool(message.iconEnabled);
        /* int32 ring_count = 5; */
        if (message.ringCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.ringCount);
        /* int32 reminder_minutes = 6; */
        if (message.reminderMinutes !== 0)
            writer.tag(6, WireType.Varint).int32(message.reminderMinutes);
        /* int32 escalation_minutes = 7; */
        if (message.escalationMinutes !== 0)
            writer.tag(7, WireType.Varint).int32(message.escalationMinutes);
        /* int32 max_reminders = 8; */
        if (message.maxReminders !== 0)
            writer.tag(8, WireType.Varint).int32(message.maxReminders);
        /* int32 max_age_days = 9; */
        if (message.maxAgeDays !== 0)
            writer.tag(9, WireType.Varint).int32(message.maxAgeDays);
        /* bool popup_on_new = 10; */
        if (message.popupOnNew !== false)
            writer.tag(10, WireType.Varint).bool(message.popupOnNew);
        /* bool popup_on_login = 11; */
        if (message.popupOnLogin !== false)
            writer.tag(11, WireType.Varint).bool(message.popupOnLogin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.TopupAttentionSettingsDTO
 */
export const TopupAttentionSettingsDTO = new TopupAttentionSettingsDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TopupAttentionSettingsResponse$Type extends MessageType<TopupAttentionSettingsResponse> {
    constructor() {
        super("vlp.billing.TopupAttentionSettingsResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => TopupAttentionSettingsDTO }
        ]);
    }
    create(value?: PartialMessage<TopupAttentionSettingsResponse>): TopupAttentionSettingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TopupAttentionSettingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TopupAttentionSettingsResponse): TopupAttentionSettingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.billing.TopupAttentionSettingsDTO data */ 2:
                    message.data = TopupAttentionSettingsDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TopupAttentionSettingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.billing.TopupAttentionSettingsDTO data = 2; */
        if (message.data)
            TopupAttentionSettingsDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.TopupAttentionSettingsResponse
 */
export const TopupAttentionSettingsResponse = new TopupAttentionSettingsResponse$Type();
